/** Typed reader for the server-rendered `#__config` JSON data island. */

// Single source of truth, shared with the raft SSR producer. Type-only import,
// so the Zod runtime (and its weight) does NOT enter the client bundle.
import { Islands, type WindowConfig } from "@brave-new-world/shared";
import { readIsland } from "./ui/islands";

// The raft `ConfigScript` component emits the config as a non-executable
// `<script type="application/json" id="__config">` island, rendered before
// this bundle's script tag — no `window` global involved. Parsed on first
// property access; only a successful parse is cached, so an early miss can't
// poison later reads.
let cached: WindowConfig | undefined;

function readConfig(): WindowConfig | undefined {
  if (cached === undefined && typeof document !== "undefined") {
    cached = readIsland(Islands.config);
  }
  return cached;
}

export const config: WindowConfig = new Proxy({} as WindowConfig, {
  get(_target, prop: string) {
    const c = readConfig();
    return c ? (c as unknown as Record<string, unknown>)[prop] : undefined;
  },
});
